import { IMarkedListItem } from '../../types/offersData';
import { IApplicationState } from '../../types/redux';

export const getMarkedListItems = (state: IApplicationState): IMarkedListItem[] => {
  return state.offersData.seo?.markedListV2?.items || [];
};
